<template>
  <v-dialog v-model="showModal" max-width="800">
    <v-form ref="form" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $tc('label.justificativa', 1) }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            id="justificativa"
            v-if="!obrigatorio && !somenteLeitura"
            name="justificativa"
            :label="`${$tc('label.justificativa', 1)}`"
            v-model="justificativa"
            auto-grow
            autofocus
            rows="1"
            :disabled="somenteLeitura"
          ></v-textarea>
          <v-textarea
            id="justificativa_obrigatoria"
            v-if="obrigatorio && !somenteLeitura"
            name="justificativa-obrigatoria"
            :label="`${$tc('label.justificativa', 1)} *`"
            v-model="justificativa"
            auto-grow
            autofocus
            rows="1"
            :rules="[rules.required]"
            :disabled="somenteLeitura"
          ></v-textarea>
          <v-textarea
            v-if="somenteLeitura"
            name="observacao"
            :label="`${$tc('label.justificativa', 1)}`"
            :value="observacao"
            auto-grow
            rows="1"
            :disabled="somenteLeitura"
          ></v-textarea>
          <v-text-field
            v-if="exigePoEvidencia && !somenteLeitura"
            v-model="numeroPedidoCompra"
            :label="`${$t('label.numero_pedido_compra')} *`"
            :rules="[rules.required, rules.alfanumerico]"
          ></v-text-field>
          <v-input
            v-if="exigePoEvidencia && !somenteLeitura"
            :value="arquivosEvidencia"
            :rules="[rules.evidenciasObrigatorias, rules.evidenciasLimite]"
            hide-details="auto"
            class="PlanejamentoAcaoJustificativa__evidencias-input">
            <template v-slot:default>
              <v-file-input
                :key="fileInputKey"
                v-model="fileInputSelecao"
                :label="labelAnexarEvidencias"
                accept=".pdf,application/pdf"
                multiple
                show-size
                prepend-icon="attach_file"
                :disabled="arquivosEvidencia.length >= maxArquivosEvidencia"
                clearable
                @change="onEvidenciasSelecionadas"
              ></v-file-input>
              <div
                v-if="arquivosEvidencia.length"
                class="caption grey--text text--darken-1 mb-1">
                {{ contadorEvidencias }}
              </div>
              <v-list
                v-if="arquivosEvidencia.length"
                dense
                class="PlanejamentoAcaoJustificativa__lista-evidencias">
                <v-list-item
                  v-for="(arquivo, indice) in arquivosEvidencia"
                  :key="chaveArquivoEvidencia(arquivo, indice)">
                  <v-list-item-content>
                    <v-list-item-title>{{ arquivo.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ formatarTamanhoArquivo(arquivo.size) }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon small @click="removerEvidencia(indice)">
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </template>
          </v-input>
        </v-card-text>

        <v-container grid-list-xl>
          <metadados-container-layout v-if="indCamposDinamicos"
            :metadados-entidade="metadadosCampos"
            :layout-class="layoutClass"
            :input-layout="inputLayout"
            :objeto="listaCamposDinamicos"
            ref="container">
          </metadados-container-layout>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="somenteLeitura" text @click.native="cancela">{{ $t('label.fechar') }}</v-btn>
          <v-btn v-if="!somenteLeitura" text @click.native="cancela">
            {{ exigePoEvidencia ? $t('label.fechar') : $t('label.cancelar') }}
          </v-btn>
          <v-btn v-if="!somenteLeitura" color="primary darken-1" text @click.native="salvar">
            {{ exigePoEvidencia ? $t('label.aprovar') : $t('label.salvar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import MetadadosContainerLayout from '../../produto/shared-components/metadados/MetadadosContainerLayout';

const TAMANHO_MAXIMO_BYTES = 15 * 1024 * 1024;
const MAX_ARQUIVOS_EVIDENCIA = 5;

export default {
  data() {
    return {
      showModal: false,
      justificativa: '',
      numeroPedidoCompra: '',
      arquivosEvidencia: [],
      fileInputSelecao: null,
      fileInputKey: 0,
      maxArquivosEvidencia: MAX_ARQUIVOS_EVIDENCIA,
      layoutClass: {
        wrap: true,
      },
      inputLayout: {
        xs12: true,
        sm6: true,
        md12: true,
      },
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        alfanumerico: (value) => this.poAlfanumerico(value) || this.$t('message.formato_invalido_alfanumerico'),
        evidenciasObrigatorias: () => (this.arquivosEvidencia.length > 0) || this.$t('message.campo_obrigatorio'),
        evidenciasLimite: () => this.evidenciasValidas(this.arquivosEvidencia)
          || this.$t('message.evidencia_limite_arquivos'),
      },
    };
  },
  props: {
    obrigatorio: Boolean,
    salvarJustificativa: Function,
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    observacao: String,
    config: {
      type: Object,
      default: null,
    },
    acao: {
      type: Object,
      required: false,
    },
    exigePoEvidencia: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MetadadosContainerLayout,
  },
  computed: {
    ...mapGetters('metadados', [
      'getAcaoMetadado',
    ]),
    labelAnexarEvidencias() {
      const base = this.$t('label.evidencias');
      return `${base} * (${this.$t('label.anexar')} — PDF, máx. ${MAX_ARQUIVOS_EVIDENCIA} × 15MB)`;
    },
    contadorEvidencias() {
      return `${this.arquivosEvidencia.length} / ${MAX_ARQUIVOS_EVIDENCIA}`;
    },
    indCamposDinamicos() {
      return this.config && this.config.passo3 && this.config.passo3.listaDinamica
       && this.config.passo3.listaDinamica.filter((value) => value.indHabilitaAprovacaoPlanejamento).length > 1;
    },
    listaCamposDinamicos() {
      const acaoEdicao = {};
      Object.assign(acaoEdicao, this.acao);
      if (this.acao && this.acao.passoGeral && this.acao.passoGeral.mapaCamposDinamicos) {
        Object.assign(acaoEdicao,
          {
            ...this.acao.passoGeral,
            ...this.acao.passoGeral.mapaExtensoes,
            ...this.acao.passoGeral.mapaCamposDinamicos,
          });
      }
      return acaoEdicao;
    },
    metadadosCampos() {
      if (this.getAcaoMetadado && this.getAcaoMetadado.mapaCamposDinamicos) {
        const metadados = { ...this.getAcaoMetadado };
        const resultado = {};
        const campos = metadados.mapaCamposDinamicos;
        if (this.config && this.config.passo3) {
          this.config.passo3.listaDinamica.forEach((a) => {
            Object.keys(campos).forEach((key) => {
              if (key === a.label && (a.indHabilitaAprovacaoPlanejamento)) {
                resultado[key] = campos[key];
              }
            });
          });
        }
        metadados.mapaCamposDinamicos = resultado;
        metadados.mapaEntidades = {};
        metadados.dicionario = {};
        return metadados;
      }
      return undefined;
    },
  },
  methods: {
    open() {
      this.justificativa = '';
      this.numeroPedidoCompra = '';
      this.arquivosEvidencia = [];
      this.fileInputSelecao = null;
      this.fileInputKey += 1;
      this.showModal = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    cancela() {
      this.showModal = false;
    },
    poAlfanumerico(value) {
      if (!value) {
        return false;
      }
      return /[0-9A-Za-z]/.test(value);
    },
    chaveArquivoEvidencia(arquivo, indice) {
      if (!arquivo) {
        return indice;
      }
      return `${arquivo.name}-${arquivo.size}-${arquivo.lastModified || indice}`;
    },
    formatarTamanhoArquivo(bytes) {
      if (bytes == null || Number.isNaN(bytes)) {
        return '';
      }
      if (bytes < 1024) {
        return `${bytes} B`;
      }
      if (bytes < 1024 * 1024) {
        return `${(bytes / 1024).toFixed(1)} KB`;
      }
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    },
    evidenciaDuplicada(arquivo) {
      return this.arquivosEvidencia.some(
        (item) => item.name === arquivo.name
          && item.size === arquivo.size
          && item.lastModified === arquivo.lastModified,
      );
    },
    onEvidenciasSelecionadas(arquivos) {
      if (!arquivos) {
        return;
      }
      const lista = Array.isArray(arquivos) ? arquivos : [arquivos];
      lista.forEach((arquivo) => this.tentarAdicionarEvidencia(arquivo));
      this.fileInputSelecao = null;
      this.fileInputKey += 1;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validate();
        }
      });
    },
    tentarAdicionarEvidencia(arquivo) {
      if (!arquivo) {
        return;
      }
      if (this.arquivosEvidencia.length >= MAX_ARQUIVOS_EVIDENCIA) {
        this.$toast(this.$t('message.evidencia_maximo_atingido'));
        return;
      }
      if (!this.arquivoPdfValido(arquivo)) {
        this.$toast(this.$t('message.evidencia_pdf_15mb'));
        return;
      }
      if (this.evidenciaDuplicada(arquivo)) {
        this.$toast(this.$t('message.evidencia_ja_anexada'));
        return;
      }
      this.arquivosEvidencia.push(arquivo);
    },
    removerEvidencia(indice) {
      this.arquivosEvidencia.splice(indice, 1);
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validate();
        }
      });
    },
    evidenciasValidas(arquivos) {
      if (!arquivos || !arquivos.length) {
        return false;
      }
      if (arquivos.length > MAX_ARQUIVOS_EVIDENCIA) {
        return false;
      }
      return arquivos.every((arquivo) => this.arquivoPdfValido(arquivo));
    },
    arquivoPdfValido(arquivo) {
      if (!arquivo) {
        return false;
      }
      const nome = (arquivo.name || '').toLowerCase();
      const tipo = arquivo.type || '';
      const pdf = nome.endsWith('.pdf') || tipo === 'application/pdf';
      return pdf && arquivo.size <= TAMANHO_MAXIMO_BYTES;
    },
    salvar() {
      if (!this.$refs.form.validate()) return;
      this.salvarJustificativa(this.justificativa, this.getValoresMetadados(), {
        numeroPedidoCompra: this.numeroPedidoCompra,
        arquivosEvidencia: this.arquivosEvidencia,
      });
      this.showModal = false;
    },
    getValoresMetadados() {
      if (this.indCamposDinamicos) {
        return { ...this.$refs.container.getValoresCamposDinamicos() };
      }
      return undefined;
    },
  },
};
</script>
<style scoped>
.PlanejamentoAcaoJustificativa__evidencias-input {
  width: 100%;
}
.PlanejamentoAcaoJustificativa__lista-evidencias {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  max-height: 220px;
  overflow-y: auto;
}
</style>
